<template>
    <div>
        <v-autocomplete
                v-model="reason"
                :label="label"
                :items="medicalReasonStore.medicalReasons"
                item-value="id"
                item-text="name"
                outlined
                :color="inputColor"
                :background-color="backgroundColor"
                dense
                :readonly="readonly"
                :clearable="!readonly"
                :multiple="multiple"
                hide-details="auto"
                @input="$emit('input', reason)"
                :rules="rules"
        ></v-autocomplete>

        <input type="hidden"/>
    </div>
</template>


<script>
import useSharedData from "@/use/SharedData";
import {onMounted, ref, watch} from "vue";
import {useMedicalReasonStore} from "@/stores/Medical/MedicalReason";
import axios from "axios";

export default {
    name: "StrMedicalReasonAutocomplete",
    props: {
        value: [Number, Array],
        readonly: Boolean,
        label: String,
        multiple: Boolean,
        rules: Array,
    },
    setup(props) {
        const {loading, inputColor, backgroundColor} = useSharedData();
        const medicalReasonStore = useMedicalReasonStore();
        const reason = ref(null);

        function findAll() {
          loading.value = true;
          axios.get(`/medicalReasons`).then(response => {
             medicalReasonStore.setMedicalReasons(response.data);
          }).finally(() => {
              loading.value = false;
          });
        }

        watch(() => props.value, () => {
            reason.value = props.value;
        }, {immediate: true});

        onMounted(() => findAll());

        return {
            medicalReasonStore,
            loading,
            reason,
            inputColor,
            backgroundColor
        }
    }
};
</script>